<template>
    <v-card>
        <v-container fluid grid-list-xl>
            <v-card-text class="pt-0 pb-2 pr-2">
                <v-layout wrap align-center>
                    <!-- search for file title -->
                    <v-flex xs6 sm6 lg3 d-flex>
                        <v-text-field
                            class="mb-0 pb-0"
                            hide-details
                            append-icon="mdi-magnify"
                            type="text"
                            label="File Name"
                            v-model="fileTitleFilterValue"
                        ></v-text-field>
                    </v-flex>
                    <!-- search for file number -->
                    <v-flex xs6 sm6 lg2 d-flex>
                        <v-text-field
                            class="mb-0 pb-0"
                            hide-details
                            append-icon="mdi-magnify"
                            type="text"
                            label="File Number"
                            v-model="fileNumberFilterValue"
                        ></v-text-field>
                    </v-flex>
                    <!-- select sattus -->
                    <v-flex xs12 sm6 lg2 d-flex>
                        <v-select
                            class="mb-0 pb-0"
                            append-icon="mdi-filter"
                            hide-details
                            :items="statusOptions"
                            label="Status"
                            v-model="statusSelectedValue"
                        ></v-select>
                    </v-flex>

                    <!-- select date range-->
                    <v-flex xs12 sm6 lg3 d-flex>
                        <v-menu
                            ref="menu"
                            v-model="menu"
                            :close-on-content-click="false"
                            :return-value.sync="dates"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    class="mb-0 pb-0"
                                    hide-details
                                    append-icon="mdi-calendar"
                                    v-model="dateRangeText"
                                    label="Date Range"
                                    readonly
                                    v-bind="attrs"
                                    v-on="on"
                                ></v-text-field>
                            </template>

                            <v-date-picker v-model="dates" range no-title scrollable>
                                <v-btn text color="primary" @click="menu = false">Cancel</v-btn>
                                <v-btn text color="primary" @click="$refs.menu.save(dates)">OK</v-btn>
                                <v-btn text color="primary" @click="$refs.menu.save([])">Clear </v-btn>
                            </v-date-picker>
                        </v-menu>
                    </v-flex>
                    <v-flex xs12 sm12 lg2 d-flex>
                        <v-switch
                            hide-details
                            v-if="!swithText"
                            v-model="moreFilters"
                            label="Show More Filters"
                            class="pa-3"
                        ></v-switch>
                        <v-switch
                            hide-details
                            v-if="swithText"
                            v-model="moreFilters"
                            label="Hide Filters"
                            class="pa-3"
                        ></v-switch>
                    </v-flex>
                    <!-- search for reviewer emails -->
                    <v-flex xs12 sm6 lg3 d-flex v-if="moreFilters">
                        <v-text-field
                            append-icon="mdi-magnify"
                            type="text"
                            v-model="reviewerEmailInput"
                            label="Reviewer Email Search"
                        ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg4 d-flex v-if="moreFilters">
                        <v-autocomplete
                            append-icon="mdi-select-all"
                            :items="multipleInitiatorSelectOptionsModified"
                            v-model="selectedInitiators"
                            item-value="id"
                            item-text="name"
                            label="Select Initiators"
                            multiple
                            chips
                            dense
                            deletable-chips
                        >
                        </v-autocomplete>
                    </v-flex>
                    <v-flex xs12 sm12 lg5 d-flex v-if="moreFilters">
                        <v-autocomplete
                            append-icon="mdi-select-all"
                            :items="multipleCompanySelectOptions"
                            v-model="selectedCompanies"
                            item-value="id"
                            item-text="name"
                            label="Select Companies"
                            multiple
                            chips
                            dense
                            deletable-chips
                        >
                        </v-autocomplete>
                    </v-flex>
                </v-layout>
            </v-card-text>
            <v-data-table
                :headers="headers"
                :items="dataForTable[0]"
                :single-expand="singleExpand"
                :custom-sort="customSort"
                :sort-by="'createdAt'"
                :sort-desc="true"
                item-key="title"
                show-expand
                class="elevation-1"
            >
                <template v-slot:item.title="{ item }">{{ item.title }}</template>
                <template v-slot:item.createdAt="{ item }">{{ formatDate(item.createdAt) }}</template>
                <template v-slot:item.docs[]="{ item }">
                    <template>
                        <span>
                            <v-btn class="pr-1 pl-1" text small @click.native="openViewDocsDialog(item.docs)"
                                >View Docs</v-btn
                            >
                        </span>
                    </template>
                </template>
                <template v-slot:item.overAll="{ item }">
                    <span :class="item.overAllColorClass">{{ item.overAll }}</span>
                </template>
                <template v-slot:item.comment="{ item }">
                    <v-btn
                        v-if="item.comment !== null && item.comment !== ''"
                        icon
                        @click.native="openEmailMessageDialog(item)"
                    >
                        <v-icon>mdi-comment-alert</v-icon>
                    </v-btn>
                </template>
                <template v-slot:item.docId="{ item }">
                    <v-btn icon @click.native="openAddApproverDialog(item)">
                        <v-icon>mdi-email-plus</v-icon>
                    </v-btn>
                </template>
                <template v-slot:expanded-item="{ item }">
                    <td :colspan="headers.length">
                        <table>
                            <tr>
                                <td style="font-weight:bold">Email</td>
                                <td style="font-weight:bold">Approval State</td>
                                <td v-if="$store.getters.hasAdmin">
                                    <v-btn icon @click.native="resendAll(item.docId)">
                                        <v-icon>mdi-email-multiple</v-icon>
                                    </v-btn>
                                    Resend All Awaiting
                                </td>
                                <td style="font-weight:bold">
                                    Attachments
                                </td>

                                <td style="font-weight:bold">Comment</td>

                                <td v-if="$store.getters.hasAdmin" style="font-weight:bold">Remove Approver</td>
                            </tr>
                            <tr v-for="(record, index) in item.users" :key="index">
                                <td>{{ record.email }}</td>
                                <td :class="record.approvalColorClass">{{ record.approved }}</td>
                                <td v-if="$store.getters.hasAdmin">
                                    <v-btn icon @click.native="resend(item.docId, record.email)">
                                        <v-icon>mdi-email</v-icon>
                                    </v-btn>
                                    Resend
                                </td>
                                <td>
                                    <v-btn
                                        icon
                                        @click.native="openAttachmentDialog(record)"
                                        v-if="record.hasAttachment"
                                    >
                                        <v-icon>mdi-file</v-icon>
                                    </v-btn>
                                </td>

                                <td>
                                    <v-btn icon @click.native="openCommentDialog(record)" v-if="record.hasComment">
                                        <v-icon>mdi-comment-alert</v-icon>
                                    </v-btn>
                                </td>
                                <td v-if="$store.getters.hasAdmin">
                                    <v-btn
                                        icon
                                        @click.native="openConfirmRemoveDialog(record, item)"
                                        v-if="record.removable"
                                    >
                                        <v-icon>mdi-delete-forever</v-icon>
                                    </v-btn>
                                </td>
                            </tr>
                        </table>
                    </td>
                </template>
            </v-data-table>
        </v-container>

        <v-dialog v-model="addApproverDialog" max-width="450px">
            <v-card>
                <v-flex xs12>
                    <v-card-title class="hubblue white--text">Email</v-card-title>
                </v-flex>
                <v-card-text>
                    <v-row align="center">
                        <v-text-field
                            v-model="newEmail"
                            label="Reviewer Email"
                            :counter="50"
                            :error-messages="errors.collect('email')"
                            v-validate="'email|required'"
                            class="requires--text"
                            data-vv-name="email"
                            data-cy="txtEmail"
                        ></v-text-field>
                    </v-row>
                    <v-row align="center">
                        <v-checkbox
                            v-model="newCC"
                            label="CC (Approval Not Required)"
                            color="hubblue"
                            data-cy="chkCC"
                        ></v-checkbox>
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-btn class="blue--text darken-1" @click.native="addApproverDialog = false">Cancel</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn class="hubblue" dark type="submit" @click.native="save()" data-cy="btnSave">
                        <v-icon>mdi-plus</v-icon>
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="commentDialog" max-width="450px">
            <v-card>
                <v-flex xs12>
                    <v-card-title class="hubblue white--text">Comment</v-card-title>
                </v-flex>
                <v-card-text class="black--text mt-2">
                    <p class="body-1">
                        {{ userForCommentDialog.email }}'s status is
                        <span :style="userForCommentDialog.approvalColor">{{ userForCommentDialog.approved }}</span>
                        with the comment:
                    </p>
                    <p class="body-2">{{ userForCommentDialog.comment }}</p>
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn class="blue--text darken-1" @click.native="commentDialog = false">Close</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="emailMessageDialog" max-width="450px">
            <v-card>
                <v-flex xs12>
                    <v-card-title class="hubblue white--text">Message Sent With Email</v-card-title>
                </v-flex>
                <v-card-text class="black--text mt-2">
                    <p class="body-1">
                        This document was sent with the following message:
                    </p>
                    <p class="body-1">{{ chosenDocEmail.comment }}</p>
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn class="blue--text darken-1" @click.native="closeEmailMessageDialog()">Close</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="approvalAttachmentDialog" max-width="450px">
            <v-card>
                <v-flex xs12>
                    <v-card-title class="hubblue white--text">Attachments Sent With Email</v-card-title>
                </v-flex>
                <v-card-text class="black--text mt-2">
                    <v-list rounded nav dense>
                        <v-list-item-group>
                            <v-list-item
                                v-for="(doc, index) in approvalAttachments"
                                :key="index"
                                v-if="doc.scanStatus === 'CLEAN'"
                            >
                                <v-list-item-content rounded>
                                    <v-list-item-title rounded>
                                        <a
                                            :href="doc.docUrl"
                                            target="_blank"
                                            style="text-decoration : none; color : #000000;"
                                        >
                                            {{ doc.docName }}
                                        </a>
                                    </v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list-item-group>
                    </v-list>
                    <div v-for="(doc, index) in approvalAttachments">
                        <span color="orange" v-if="doc.scanStatus === 'IN PROGRESS'">
                            <b>{{ doc.docName }}</b> is still being scanned for viruses. The process will be complete
                            momentarily.
                        </span>
                    </div>
                    <p class="body-1" v-if="selectedDocHasInfectedFile">
                        This approval has file attachments that have been virus scanned, and come back as infected. Be
                        careful of the files you download and intend to share. If you feel this is in error, contact
                        403-993-7761 or email support@ajmenv.com.
                    </p>
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn class="blue--text darken-1" @click.native="closeApprovalAttachmentDialog()">Close</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="confirmDeleteDialog" persistent max-width="450px">
            <v-card>
                <v-flex xs12>
                    <v-card-title class="hubblue white--text">Are you sure?</v-card-title>
                </v-flex>
                <v-card-text class="black--text mt-2">
                    <p class="body-1">
                        You have selected to remove {{ userForDelete.email }} from {{ docEditedAfterRemove.title }}, are
                        you sure?
                    </p>
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn color="hubblue" class="white--text" @click.native="deleteApprovalRecord()">Confirm</v-btn>
                    <v-btn class="blue--text darken-1" @click.native="closeConfirmRemoveDialog()">Cancel</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="viewDocsDialog" width="500">
            <v-card>
                <v-card-title class="hubblue white--text">
                    Docs Sent With Email
                </v-card-title>
                <v-list rounded nav dense>
                    <v-list-item-group>
                        <v-list-item v-for="(doc, index) in docViews" :key="index" v-if="doc.scanStatus === 'CLEAN'">
                            <v-list-item-content rounded>
                                <v-list-item-title rounded>
                                    <a
                                        :href="doc.docUrl"
                                        target="_blank"
                                        style="text-decoration : none; color : #000000;"
                                    >
                                        {{ doc.docName }}
                                    </a>
                                </v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list-item-group>
                </v-list>
                <div v-for="(doc, index) in docViews">
                    <span color="orange" v-if="doc.scanStatus === 'IN PROGRESS'">
                        <b>{{ doc.docName }}</b> is still being scanned for viruses. The process will be complete
                        momentarily.
                    </span>
                </div>
                <p class="body-1" v-if="selectedDocHasInfectedFile">
                    This approval has file attachments that have been virus scanned, and come back as infected. Be
                    careful of the files you download and intend to share. If you feel this is in error, contact
                    403-993-7761 or email support@ajmenv.com.
                </p>

                <v-divider></v-divider>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="closeDocViewsDialog">
                        Close
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-card>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
import FuzzySearch from 'fuzzy-search'
import dcopy from 'deep-copy'
import { authHeader } from '../components/_helpers'

export default {
    $_veeValidate: {
        validator: 'new' // give me a new validator each time.
    },
    data() {
        return {
            loading: false,

            snackbar: false,
            snackbarMessage: null,
            snackbarContext: '',

            approval: [],
            doc: [],
            users: [],

            dataForTable: [],
            originalData: [],
            expanded: [],
            singleExpand: true,

            emailMessageDialog: false,
            chosenDocEmail: {},
            addApproverDialog: false,
            commentDialog: false,
            userForCommentDialog: {},
            confirmDeleteDialog: false,
            userForDelete: {},
            docEditedAfterRemove: {},
            newApproverRecord: null,
            newEmail: null,
            newCC: false,
            approvalAttachmentDialog: false,
            approvalAttachments: [],

            fileTitleFilterValue: '',
            fileNumberFilterValue: '',
            statusOptions: [
                { text: 'All', value: null },
                { text: 'Email Sent', value: 'Email Sent' },
                { text: 'Approved', value: 'Approved' },
                { text: 'Changes Requested', value: 'Changes Requested' },
                { text: 'Approval Not Required', value: 'Approval Not Required' }
            ],
            statusSelectedValue: null,

            dates: [],
            menu: false,

            reviewerEmailInput: null,

            selectedInitiators: [],
            multipleInitiatorSelectOptions: [],

            selectedCompanies: [],
            multipleCompanySelectOptions: [],

            moreFilters: false,

            viewDocsDialog: false,
            docViews: [],
            selectedDocHasInfectedFile: false
        }
    },
    computed: {
        headers() {
            let headers = [
                {
                    text: 'Title',
                    value: 'title',
                    filter: this.nameFilter
                },
                {
                    text: 'Date',
                    value: 'createdAt',
                    filter: this.dateRangeFilter
                },
                {
                    text: 'File Number',
                    value: 'fileNumber',
                    filter: this.fileNumberFilter
                },
                {
                    text: 'Documents',
                    value: 'docs[]',
                    sortable: false
                },
                {
                    text: 'Status',
                    value: 'overAll',
                    filter: this.statusFilter
                },
                {
                    text: 'Message',
                    value: 'comment',
                    sortable: false
                }
            ]

            if (this.$store.getters.hasAdmin) {
                headers.push({
                    text: 'Add Approver',
                    value: 'docId',
                    sortable: false
                })
            }

            headers.push({
                text: '',
                value: 'data-table-expand',
                sortable: false
            })

            return headers
        },
        dateRangeText() {
            return this.dates.join(' ~ ')
        },
        swithText() {
            return this.moreFilters ? true : false
        },
        multipleInitiatorSelectOptionsModified() {
            let options = []
            for (let option of this.multipleInitiatorSelectOptions) {
                if (option !== ' ') {
                    options.push(option)
                }
            }
            return options
        }
    },
    methods: {
        openViewDocsDialog(docs) {
            this.viewDocsDialog = true
            for (let doc of docs) {
                if (doc.scanStatus === 'INFECTED' || doc.scanStatus === 'ERROR') {
                    this.selectedDocHasInfectedFile = true
                    continue
                } else if (doc.scanStatus === 'IN PROGRESS' || doc.scanStatus === 'CLEAN') {
                    this.docViews.push({ docName: doc.docName, docUrl: doc.docUrl, scanStatus: doc.scanStatus })
                }
            }
        },
        closeDocViewsDialog() {
            this.viewDocsDialog = false
            this.selectedDocHasInfectedFile = false
            this.docViews = []
        },
        save() {
            let app = this
            app.$validator
                .validateAll()
                .then(validated => {
                    if (validated) {
                        app.AddApprover()
                    } else {
                        let snackbarParams = {
                            message: 'Failed to create Approver',
                            context: 'error'
                        }
                        app.$store.commit('showSnackbar', snackbarParams)
                    }
                })
                .catch(() => {
                    return false
                })
        },
        AddApprover() {
            let app = this
            let snackbarParams

            let params = {
                docId: app.newApproverRecord.docId,
                replyTo: app.$store.state.authentication.loggedInUser.email,
                email: app.newEmail,
                cc: app.newCC,
                originUrl: window.location.origin
            }
            let headers = {
                headers: {
                    Authorization: JSON.parse(localStorage.getItem('user'))
                }
            }
            axios
                .post(app.$store.state.docUrl + '/addapprover', params, headers)
                .then(response => {
                    app.loading = false
                    snackbarParams = {
                        message: response.data,
                        context: 'success'
                    }
                    app.$store.commit('showSnackbar', snackbarParams)
                    app.newEmail = null
                    app.newCC = false
                    app.addApproverDialog = false
                    app.newApproverRecord = null
                    this.get()
                })
                .catch(error => {
                    console.log(error)
                    app.loading = false
                    snackbarParams = {
                        message: error.response.data,
                        context: 'error'
                    }
                    app.$store.commit('showSnackbar', snackbarParams)
                })
        },
        openAddApproverDialog(item) {
            this.newApproverRecord = item
            this.newEmail = ''
            this.ccUpdate = false
            this.addApproverDialog = true
        },
        openEmailMessageDialog(item) {
            this.chosenDocEmail = item
            this.emailMessageDialog = true
        },
        closeEmailMessageDialog() {
            this.chosenDocEmail = {}
            this.emailMessageDialog = false
        },
        openCommentDialog(item) {
            this.userForCommentDialog = item
            this.commentDialog = true
        },
        openConfirmRemoveDialog(user, doc) {
            this.userForDelete = user
            this.docEditedAfterRemove = doc
            this.confirmDeleteDialog = true
        },
        openAttachmentDialog(record) {
            for (let doc of record.docApprovalAttachments) {
                if (doc.scanStatus === 'INFECTED' || doc.scanStatus === 'ERROR') {
                    this.selectedDocHasInfectedFile = true
                    continue
                } else if (doc.scanStatus === 'IN PROGRESS' || doc.scanStatus === 'CLEAN') {
                    this.approvalAttachments.push({
                        docName: doc.docName,
                        docUrl: doc.docUrl,
                        scanStatus: doc.scanStatus
                    })
                }
            }

            this.approvalAttachmentDialog = true
        },
        closeApprovalAttachmentDialog() {
            this.approvalAttachments = []
            this.selectedDocHasInfectedFile = false
            this.approvalAttachmentDialog = false
        },
        closeConfirmRemoveDialog() {
            this.userForDelete = {}
            this.docEditedAfterRemove = {}
            this.confirmDeleteDialog = false
        },
        resendAll(docId) {
            let app = this
            let snackbarParams

            let params = {
                docId: docId,
                replyTo: app.$store.state.authentication.loggedInUser.email,
                originUrl: window.location.origin
            }
            let headers = {
                headers: {
                    Authorization: JSON.parse(localStorage.getItem('user'))
                }
            }
            axios
                .post(app.$store.state.docUrl + '/resendall', params, headers)
                .then(response => {
                    app.loading = false
                    snackbarParams = {
                        message: response.data,
                        context: 'success'
                    }
                    app.$store.commit('showSnackbar', snackbarParams)
                })
                .catch(error => {
                    console.log(error)
                    app.loading = false
                    snackbarParams = {
                        message: error.response.data,
                        context: 'error'
                    }
                    app.$store.commit('showSnackbar', snackbarParams)
                })
        },
        resend(docId, email) {
            let app = this
            let snackbarParams

            let params = {
                docId: docId,
                email: email,
                replyTo: app.$store.state.authentication.loggedInUser.email,
                originUrl: window.location.origin
            }
            let headers = {
                headers: {
                    Authorization: JSON.parse(localStorage.getItem('user'))
                }
            }
            axios
                .post(app.$store.state.docUrl + '/resend', params, headers)
                .then(response => {
                    app.loading = false
                    snackbarParams = {
                        message: 'Resend Complete',
                        context: 'success'
                    }
                    app.$store.commit('showSnackbar', snackbarParams)
                })
                .catch(error => {
                    console.log(error)
                    app.loading = false
                    snackbarParams = {
                        message: error.response.data,
                        context: 'error'
                    }
                    app.$store.commit('showSnackbar', snackbarParams)
                })
        },
        setRootTableRow(data) {
            let _data = {
                docId: data.docId,
                title: data.docTitle,
                createdAt: moment(data.createdAt),
                userId: data.userId,
                comment: data.comment,
                fileNumber: data.fileNumber,
                initiatorCompanyId: data.companyId,
                docApprovals: data.docApprovals,
                docs: [],
                users: [],
                overAll: null,
                overAllColorClass: null
            }
            this.approval.push(_data)
        },
        addDoc(data) {
            let idx = this.approval.findIndex(approval => approval.docId === data.docId)
            let _data = {
                docId: data.docId,
                docUrl: data.docUrl,
                docName: decodeURI(data.originalDocName),
                scanStatus: data.scanStatus
            }

            this.approval[idx].docs.push(_data)
        },
        addUser(data, attachments) {
            let idx = this.approval.findIndex(approval => approval.docId === data.docId)
            let _data = {
                docId: data.docId,
                email: data.email,
                approved: data.approvalState.approvalStateName,
                docApprovalId: data.docApprovalId,
                docApprovalAttachments: []
            }
            if (data.comment !== null && data.comment !== '' && data.comment !== 'null') {
                _data.comment = data.comment
                _data.hasComment = true
            } else {
                _data.hasComment = false
            }

            switch (_data.approved) {
                case 'Awaiting Approval':
                    _data.removable = true
                    _data.approvalColorClass = 'orange--text'
                    break
                case 'Awaiting Super Approval':
                    _data.removable = true
                    _data.approvalColorClass = 'orange--text'
                    break
                case 'Changes Requested':
                    _data.removable = false
                    _data.approvalColorClass = 'red--text'
                    break
                default:
                    //cover approved, delegated, and approval not required, all a form of success so make them green
                    _data.removable = false
                    _data.approvalColorClass = 'green--text'
                    break
            }
            if (attachments && attachments.length > 0) {
                for (let attachment of attachments) {
                    if (attachment.docApprovalId === _data.docApprovalId) {
                        attachment.docName = decodeURI(attachment.originalDocName)
                        _data.docApprovalAttachments.push(attachment)
                    }
                }
            }
            _data.docApprovalAttachments.length > 0 ? (_data.hasAttachment = true) : (_data.hasAttachment = false)
            this.approval[idx].users.push(_data)
        },
        deleteApprovalRecord() {
            let app = this
            let params = {
                docId: app.userForDelete.docId,
                email: app.userForDelete.email
            }
            let snackbarParams = {}

            axios
                .delete(`${app.$store.state.docApprovalUrl}/delete`, {
                    params: params,
                    headers: authHeader()
                })
                .then(response => {
                    let idxToRemove = this.docEditedAfterRemove.users.findIndex(user => {
                        return user.email === params.email
                    })

                    this.docEditedAfterRemove.users.splice(idxToRemove, 1)

                    snackbarParams = {
                        message: 'Approver successfully removed.',
                        context: 'success'
                    }
                })
                .then(() => {
                    this.get()
                })
                .catch(err => {
                    console.log(err)
                    snackbarParams = {
                        message: err.message,
                        context: 'error'
                    }
                })
                .finally(() => {
                    app.confirmDeleteDialog = false
                    app.userForDelete = {}
                    app.docEditedAfterRemove = {}
                    app.$store.commit('showSnackbar', snackbarParams)
                })
        },
        get() {
            this.dataForTable = []
            this.approval = []
            let params = {
                companyId: this.$store.state.authentication.loggedInUser.companyId
            }

            axios
                .get(this.$store.state.dashboardUrl, {
                    params: params,
                    headers: authHeader()
                })
                .then(response => {
                    if (response.data.length > 0) {
                        let userIds = []
                        for (let i = 0; i < response.data.length; i++) {
                            userIds.push(response.data[i].userId)
                            for (let j = 0; j < response.data[i].docApprovals.length; j++) {
                                if (response.data[i].docApprovals[j].user) {
                                    userIds.push(response.data[i].docApprovals[j].user.userId)
                                }
                            }
                        }
                        this.getAllCompanyNames([...new Set(userIds)])
                        for (let i = 0; i < response.data.length; i++) {
                            let doc = response.data[i]
                            this.setRootTableRow(doc)
                            if (doc.docDetails) {
                                for (let j = 0; j < doc.docDetails.length; j++) {
                                    this.addDoc(doc.docDetails[j])
                                }
                            }

                            if (doc.docApprovals) {
                                for (let j = 0; j < doc.docApprovals.length; j++) {
                                    this.addUser(doc.docApprovals[j], doc.docApprovalAttachments)
                                }
                            }
                        }

                        for (let index = 0; index < this.approval.length; index++) {
                            const userArray = this.approval[index].users
                            let overAll = ''
                            let overAllColorClass = ''
                            let hasReq = false
                            let hasAwait = false
                            let hasNoRequirementOfApproval = false
                            let superApproved = false

                            for (let index = 0; index < userArray.length; index++) {
                                let element = userArray[index].approved
                                if (element === 'Changes Requested' && hasReq === false) {
                                    hasReq = true
                                } else if (
                                    (element === 'Awaiting Approval' || element === 'Awaiting Super Approval') &&
                                    hasAwait === false
                                ) {
                                    hasAwait = true
                                } else if (
                                    element === 'Approval Not Required' &&
                                    hasNoRequirementOfApproval === false
                                ) {
                                    hasNoRequirementOfApproval = true
                                } else if (element === 'Super Approved') {
                                    superApproved = true
                                }
                                element = null
                            }

                            if (hasReq) {
                                overAll = 'Changes Requested'
                                overAllColorClass = 'red--text'
                            } else if (superApproved) {
                                overAll = 'Super Approved'
                                overAllColorClass = 'green--text'
                            } else if (hasAwait) {
                                overAll = 'Email Sent'
                                overAllColorClass = 'orange--text'
                            } else if (hasNoRequirementOfApproval) {
                                overAll = 'Approval Not Required'
                                overAllColorClass = 'green--text'
                            } else {
                                overAll = 'Approved'
                                overAllColorClass = 'green--text'
                            }
                            this.approval[index].overAll = overAll
                            this.approval[index].overAllColorClass = overAllColorClass
                        }

                        this.dataForTable.push(this.approval)
                        this.originalData = dcopy(this.dataForTable)
                    }
                })
                .catch(error => {
                    console.log(error)
                    let snackbarParams = {
                        message: error.message,
                        context: 'error'
                    }
                    this.$store.commit('showSnackbar', snackbarParams)
                })
        },
        customSort(items, sortBy, sortDesc) {
            if (sortBy.length < 0) {
                return
            }
            if (items.length > 1) {
                items.sort((a, b) => {
                    if (sortBy[0] === 'createdAt') {
                        if (sortDesc[0]) {
                            return moment(a.createdAt).isBefore(b.createdAt) ? 1 : -1
                        } else {
                            return moment(a.createdAt).isAfter(b.createdAt) ? 1 : -1
                        }
                    } else {
                        if (sortDesc[0]) {
                            return ('' + b[sortBy]).localeCompare(a[sortBy])
                        } else {
                            return ('' + a[sortBy]).localeCompare(b[sortBy])
                        }
                    }
                })
            }
            return items
        },
        nameFilter(value) {
            if (!this.fileTitleFilterValue) {
                return true
            }
            return value.toLowerCase().includes(this.fileTitleFilterValue.toLowerCase())
        },
        fileNumberFilter(value) {
            if (!this.fileNumberFilterValue) {
                return true
            }
            return value.toLowerCase().includes(this.fileNumberFilterValue.toLowerCase())
        },
        statusFilter(value) {
            if (!this.statusSelectedValue) {
                return true
            }
            return value === this.statusSelectedValue
        },
        dateRangeFilter(value) {
            if (this.dates.length === 0) {
                return true
            }
            let date1 = this.dates[0]
            let date2 = this.dates[1]
            let filteredDate = moment(value)
            if (!date2) {
                return filteredDate.isSameOrBefore(date2, 'day') && filteredDate.isSameOrAfter(date1, 'day')
            } else {
                if (moment(date1).isSameOrBefore(date2, 'day')) {
                    return filteredDate.isSameOrBefore(date2, 'day') && filteredDate.isSameOrAfter(date1, 'day')
                } else {
                    return filteredDate.isSameOrAfter(date2, 'day') && filteredDate.isSameOrBefore(date1, 'day')
                }
            }
        },
        formatDate(date) {
            return moment(date).format('MMM DD YYYY')
        },
        getAllCompanyUsers() {
            let params = {
                companyId: this.$store.state.authentication.loggedInUser.companyId
            }
            axios
                .get(this.$store.state.userUrl, { params: params, headers: authHeader() })
                .then(response => {
                    for (let userInfo of response.data) {
                        this.multipleInitiatorSelectOptions.push({
                            name: userInfo.firstName + ' ' + userInfo.lastName,
                            id: userInfo.userId
                        })
                    }
                })
                .catch(err => console.log(err))
        },

        getAllCompanyNames(data) {
            let params = {
                userIds: data.toString()
            }
            axios
                .get(this.$store.state.companyUrl, { params: params, headers: authHeader() })
                .then(response => {
                    let companies = []
                    for (let user of response.data) {
                        let data = {
                            name: user.company.companyName,
                            id: user.company.companyId
                        }
                        companies.push(data)
                    }
                    let key = 'name'
                    this.multipleCompanySelectOptions = [...new Map(companies.map(item => [item[key], item])).values()]
                })
                .catch(err => console.log(err))
        }
    },
    watch: {
        selectedCompanies() {
            this.dataForTable = dcopy(this.originalData)
            let filteredCompanies = []
            if (this.selectedCompanies.length > 0) {
                for (let company of this.selectedCompanies) {
                    for (let data of this.dataForTable[0]) {
                        let creator = company === data.initiatorCompanyId
                        let approver = data.docApprovals.filter(docApprover => {
                            if (docApprover.user) {
                                return docApprover.user.companyId === company
                            }
                        })
                        if (creator || approver.length > 0) {
                            filteredCompanies.push(data)
                        }
                    }
                }
                let key = 'docId'
                this.dataForTable[0] = [...new Map(filteredCompanies.map(item => [item[key], item])).values()]
            } else {
                this.dataForTable = dcopy(this.originalData)
            }
        },
        reviewerEmailInput() {
            this.dataForTable = dcopy(this.originalData)
            let reviewerEmail = this.reviewerEmailInput
                .toString()
                .toLowerCase()
                .split(' ')
                .join('')
            let filteredReviewerEmail = []
            if (this.reviewerEmailInput) {
                for (let data of this.dataForTable[0]) {
                    const searcher = new FuzzySearch(data.users, ['email'], { caseSensitive: false })
                    const result = searcher.search(reviewerEmail)
                    if (result.length > 0) {
                        filteredReviewerEmail.push(data)
                        this.dataForTable[0] = filteredReviewerEmail
                    }
                }
            } else {
                this.dataForTable = dcopy(this.originalData)
            }
        },
        selectedInitiators() {
            this.dataForTable = dcopy(this.originalData)
            let filteredInitiators = []
            if (this.selectedInitiators.length !== 0) {
                for (let initiatorId of this.selectedInitiators) {
                    for (let data of this.dataForTable[0]) {
                        if (data.userId === initiatorId) {
                            filteredInitiators.push(data)
                        }
                    }
                }
                this.dataForTable[0] = filteredInitiators
            } else {
                this.dataForTable = dcopy(this.originalData)
            }
        }
    },
    created() {
        this.get()
        this.getAllCompanyUsers()
    },
    mounted() {
        //boolean set in router beforeeach if user isn't authorized to go to a route
        //was having issues calling the snackbar from the router, probably some rendering issues (snackbar called when no page technically there)
        if (this.$store.state.snackbarFromRouter) {
            let snackbarParams = {
                message: 'Unauthorized: You do not have the permissions necessary to route to that page.',
                context: 'red'
            }
            this.$store.commit('showSnackbar', snackbarParams)
        }
    }
}
</script>
